import styles from "@/overlay/components/LayerStackWindow/StyleOptionsPanel/style.module.scss";
import { TephigramToolUpdateController } from "@/overlay/components/SmartForm/ToolsForms/TephigramForm/TephigramToolUpdateController";
import { classNames } from "@/utility/jsx";
import { t } from "@lingui/core/macro";
import type { TephigramSchemaOutput } from "@mm/metx-workbench.meteomatics.com";
import { useState } from "react";

interface TephigramOptionsProps {
  title: string;
  tephigram: TephigramSchemaOutput;
}

export function TephigramOptionsPanel({ title, tephigram }: TephigramOptionsProps) {
  const [expanded, setExpanded] = useState(false);

  function toggleMenu() {
    setExpanded(!expanded);
  }

  return (
    <div className={classNames(styles["plot-title-style-panel"], "box-section--breakout")}>
      <button className={styles["expandable-panel-header"]} onClick={toggleMenu} type="button">
        <span className="material-icons">{expanded ? "expand_less" : "expand_more"}</span>
        <span className={styles.label}>
          <span className={`${styles.tag} ${styles.darkblue}`}>{t`Options`}</span>
          <span className={styles.title}>{title}</span>
        </span>
      </button>
      {expanded && <TephigramToolUpdateController tephigram={tephigram} />}
    </div>
  );
}
